import { api } from './client';
import type {
  CacheInvalidateResponse,
  CacheDeleteKeyResponse,
  KVKeysResponse,
  KVGetResponse,
  DatabaseResetResponse,
} from './types';

export function invalidateBarcode(barcode: string) {
  return api.del<CacheInvalidateResponse>(
    `/api/admin/cache/${encodeURIComponent(barcode)}`,
  );
}

export function flushAllCaches() {
  return api.del<CacheInvalidateResponse>('/api/admin/cache');
}

export function listKVKeys(params?: { prefix?: string; cursor?: string; limit?: number }) {
  const qs = new URLSearchParams();
  if (params?.prefix) qs.set('prefix', params.prefix);
  if (params?.cursor) qs.set('cursor', params.cursor);
  if (params?.limit) qs.set('limit', String(params.limit));
  const q = qs.toString();
  return api.get<KVKeysResponse>(`/api/admin/kv/keys${q ? `?${q}` : ''}`);
}

export function getKVValue(key: string) {
  return api.get<KVGetResponse>(`/api/admin/kv/get?key=${encodeURIComponent(key)}`);
}

export function deleteKVKey(key: string) {
  return api.del<CacheDeleteKeyResponse>(`/api/admin/kv/key?key=${encodeURIComponent(key)}`);
}

export function resetDatabase() {
  return api.del<DatabaseResetResponse>('/api/admin/database');
}
